<script setup lang="ts">
const prefix = 'components.search.passengersTypesRow';

const properties = defineProps<{
  type: 'adults' | 'children' | 'infants';
  minimum: number;
  maximum: number;
}>();
const count = defineModel<number>({ default: 0 });

const labelId = useId();
</script>

<template>
  <UiField
    orientation="horizontal"
    class="justify-between md:px-4 md:py-2"
  >
    <UiFieldContent>
      <UiFieldLabel
        :id="labelId"
        class="text-base font-medium"
      >
        {{ $t(`${prefix}.${properties.type}`) }}
      </UiFieldLabel>
      <UiFieldDescription>
        {{ $t(`${prefix}.${properties.type}Placeholder`) }}
      </UiFieldDescription>
    </UiFieldContent>

    <UiNumberField
      v-model="count"
      :min="properties.minimum"
      :max="properties.maximum"
      class="flex items-center gap-2"
    >
      <UiNumberFieldDecrement
        :aria-label="`${$t(`${prefix}.decrementLabel`)} ${$t(`${prefix}.${properties.type}`)}`"
        class="relative left-auto top-auto flex h-8 w-8 translate-y-0 items-center justify-center rounded-full border border-brand-primary-700 bg-brand-primary-50 p-0 text-brand-primary-700 hover:bg-brand-primary-200"
      />
      <UiNumberFieldInput
        :aria-labelledby="labelId"
        class="h-auto w-4 cursor-default border-none py-0 shadow-none focus-visible:ring-0"
        readonly
      />
      <UiNumberFieldIncrement
        :aria-label="`${$t(`${prefix}.incrementLabel`)} ${$t(`${prefix}.${properties.type}`)}`"
        class="relative right-auto top-auto flex h-8 w-8 translate-y-0 items-center justify-center rounded-full border border-brand-primary-700 bg-brand-primary-50 p-0 text-brand-primary-700 hover:bg-brand-primary-200"
      />
    </UiNumberField>
  </UiField>
</template>
